import { Link } from "react-scroll";
import {ReactComponent as HomeIcon} from "../../assets/svgIcon/HomeIcon.svg";
import AboutIcon from "../../assets/svgIcon/AboutIcon";
import ProjectIcon from "../../assets/svgIcon/ProjectIcon";
import ContactIcon from "../../assets/svgIcon/ContactIcon";
import QualificationIcon from "../../assets/svgIcon/QualificationIcon.jsx"
import "./style.css";

export default function NavBar(){
    return(
        <header className="sidebar">
            <div className="main">
                <div className="sidebar-top">
                    <div className="sidebar-logo">
                    </div>
                </div>
                <nav className="sidebar-center">
                    <ul className="flex-div">
                        <li>
                            <Link activeClass="active" smooth spy to="Home" className="flex sidebar-btn click-hover">
                                <HomeIcon/>
                            </Link>
                        </li>
                        <li>
                            <Link activeClass="active" smooth spy to="About" className="flex sidebar-btn click-hover">
                                <AboutIcon/>    
                            </Link>
                        </li>
                        <li>
                            <Link activeClass="active" smooth spy to="Qualification" className="flex sidebar-btn click-hover">
                                <QualificationIcon/>    
                            </Link>
                        </li>
                        <li>
                            <Link activeClass="active" smooth spy to="Project" className="flex sidebar-btn click-hover">
                                <ProjectIcon/>
                            </Link>
                        </li>
                        <li>
                            <Link activeClass="active" smooth spy to="Contact" className="flex sidebar-btn click-hover">
                                <ContactIcon/>
                            </Link>
                        </li>
                    </ul>
                </nav>
                <div className="sidebar-bottom">
                </div>
            </div>
        </header>
    );
}